import { render, staticRenderFns } from "./Imagens.vue?vue&type=template&id=2bd915b4&scoped=true"
import script from "./Imagens.vue?vue&type=script&lang=js"
export * from "./Imagens.vue?vue&type=script&lang=js"
import style0 from "./Imagens.vue?vue&type=style&index=0&id=2bd915b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd915b4",
  null
  
)

export default component.exports